export const monitor = () => (
  <path
    d="M8 21h8m-4-4v4M4 3h16a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
